import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/Login/LoginPage";
import DashboardPage from "./pages/Dashboard/Layout/DashboardPage";
import Homepage from "./pages/Dashboard/Home/Homepage";
import EnquiriesPage from "./pages/Dashboard/Enquiries/EnquiriesPage";
import UpdateApkPage from "./pages/Dashboard/UpdateApk/UpdateApkPage";
import SubAdminPage from "./pages/Dashboard/Admin/SubAdminPage";
import AdminLogsPage from "./pages/Dashboard/Admin/AdminLogsPage";
import TradersListPage from "./pages/Dashboard/Traders/TradersListPage";
import TraderDetailsPage from "./pages/Dashboard/Traders/TraderDetailsPage";
import KYCManagementPage from "./pages/Dashboard/KYC/KYCManagementPage";
import CurrencyManagementPage from "./pages/Dashboard/Trading/CurrencyManagementPage";
import CurrencyPairManagementPage from "./pages/Dashboard/Trading/CurrencyPairManagementPage";
import AddCurrencyPairPage from "./pages/Dashboard/Trading/AddCurrencyPairPage";
import CoinListDetailsPage from "./pages/Dashboard/Trading/CoinListDetailsPage";
import AddSpotTradingCoinPage from "./pages/Dashboard/Trading/AddSpotTradingCoinPage";
import TradingFeeReportPage from "./pages/Dashboard/Trading/TradingFeeReportPage";
import OrderBookPage from "./pages/Dashboard/Trading/OrderBookPage";
import AllOpenOrdersPage from "./pages/Dashboard/Trading/AllOpenOrdersPage";
import FuturesOpenOrdersPage from "./pages/Dashboard/Trading/FuturesOpenOrdersPage";
import FuturesPositionsPage from "./pages/Dashboard/Trading/FuturesPositionsPage";
import FuturesTradeHistoryPage from "./pages/Dashboard/Trading/FuturesTradeHistoryPage";
import FuturesPairPage from "./pages/Dashboard/Trading/FuturesPairPage";
import FundsDepositPage from "./pages/Dashboard/Funds/FundsDepositPage";
import TransferTransactionsPage from "./pages/Dashboard/Funds/TransferTransactionsPage";
import FundsWithdrawalPage from "./pages/Dashboard/Funds/FundsWithdrawalPage";
import TradingCommissionPage from "./pages/Dashboard/Trading/TradingCommissionPage";
import WithdrawalFeesPage from "./pages/Dashboard/Trading/WithdrawalFeesPage";
import ExchangeWalletPage from "./pages/Dashboard/Exchange/ExchangeWalletPage";
import LaunchpadManagementPage from "./pages/Dashboard/Exchange/LaunchpadManagementPage";
import AdminDebitCreditPage from "./pages/Dashboard/Exchange/AdminDebitCreditPage";
import AnnouncementManagementPage from "./pages/Dashboard/Exchange/AnnouncementManagementPage";
import P2POrdersPage from "./pages/Dashboard/P2P/P2POrdersPage";
import P2PAdsPage from "./pages/Dashboard/P2P/P2PAdsPage";
import P2PAdDetailsPage from "./pages/Dashboard/P2P/P2PAdDetailsPage";
import DisputeManagementPage from "./pages/Dashboard/P2P/DisputeManagementPage";
import DisputeDetailsPage from "./pages/Dashboard/P2P/DisputeDetailsPage";
import P2PFiatManagementPage from "./pages/Dashboard/P2P/P2PFiatManagementPage";
import P2PUserPaymentMethodsPage from "./pages/Dashboard/P2P/P2PUserPaymentMethodsPage";
import NotificationManagementPage from "./pages/Dashboard/Notification/NotificationManagementPage";
import SupportManagementPage from "./pages/Dashboard/Support/SupportManagementPage";
import SupportMessagePage from "./pages/Dashboard/Support/SupportMessagePage";
import PlatformConfigurationPage from "./pages/Dashboard/Platform/PlatformConfigurationPage";
import StakingPackagesPage from "./pages/Dashboard/Staking/StakingPackagesPage";
import AddStakingPackagePage from "./pages/Dashboard/Staking/AddStakingPackagePage";
import EditStakingPackagePage from "./pages/Dashboard/Staking/EditStakingPackagePage";
import StakingStakesPage from "./pages/Dashboard/Staking/StakingStakesPage";
import SendEmailPage from "./pages/Dashboard/Communication/SendEmailPage";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard/homepage" replace />} />
          <Route path="homepage" element={<Homepage />} />
          <Route path="enquiries" element={<EnquiriesPage />} />
          <Route path="listsubadmin" element={<SubAdminPage />} />
          <Route path="admin-logs" element={<AdminLogsPage />} />
          <Route path="tradelist" element={<TradersListPage />} />
          <Route path="trader/:traderId" element={<TraderDetailsPage />} />
          <Route path="pendingkyc" element={<KYCManagementPage />} />
          <Route path="coinListDetails" element={<CoinListDetailsPage />} />
          <Route path="addSpotTradingCoin" element={<AddSpotTradingCoinPage />} />
          <Route path="currencymanagement" element={<CurrencyManagementPage />} />
          <Route path="addCurrencyPair" element={<AddCurrencyPairPage />} />
          <Route path="currencypair" element={<CurrencyPairManagementPage />} />
          <Route path="tradingfeereport" element={<TradingFeeReportPage />} />
          <Route path="OrderBook" element={<OrderBookPage />} />
          <Route path="allOpenOrders" element={<AllOpenOrdersPage />} />
          <Route path="futuresPair" element={<FuturesPairPage />} />
          <Route path="futuresOpenOrders" element={<FuturesOpenOrdersPage />} />
          <Route path="futuresPositions" element={<FuturesPositionsPage />} />
          <Route path="futuresTradeHistory" element={<FuturesTradeHistoryPage />} />
          <Route path="fundsDManagement" element={<FundsDepositPage />} />
          <Route path="transferTransactions" element={<TransferTransactionsPage />} />
          <Route path="fundsWithdrawalManagement" element={<FundsWithdrawalPage />} />
          <Route path="TradingCommision" element={<TradingCommissionPage />} />
          <Route path="WithdrawalFees" element={<WithdrawalFeesPage />} />
          <Route path="exchangeWalletManagement" element={<ExchangeWalletPage />} />
          <Route path="LaunchpadManagement" element={<LaunchpadManagementPage />} />
          <Route path="AdminDebitCreditTrans" element={<AdminDebitCreditPage />} />
          <Route path="AnnouncementDetails" element={<AnnouncementManagementPage />} />
          <Route path="p2p-orders" element={<P2POrdersPage />} />
          <Route path="p2p-ads" element={<P2PAdsPage />} />
          <Route path="p2p-ad-details" element={<P2PAdDetailsPage />} />
          <Route path="dispute_management" element={<DisputeManagementPage />} />
          <Route path="dispute_Details" element={<DisputeDetailsPage />} />
          <Route path="p2p-fiat-management" element={<P2PFiatManagementPage />} />
          <Route path="p2p-user-payment-methods" element={<P2PUserPaymentMethodsPage />} />
          <Route path="notification" element={<NotificationManagementPage />} />
          <Route path="support" element={<SupportManagementPage />} />
          <Route path="support-message" element={<SupportMessagePage />} />
          <Route path="UpdateApk" element={<UpdateApkPage />} />
          <Route path="platform-configuration" element={<PlatformConfigurationPage />} />
          <Route path="staking-packages" element={<StakingPackagesPage />} />
          <Route path="staking/add-package" element={<AddStakingPackagePage />} />
          <Route path="staking/edit-package/:packageId" element={<EditStakingPackagePage />} />
          <Route path="staking/user-stakes" element={<StakingStakesPage />} />
          <Route path="send-email" element={<SendEmailPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
